import { render, staticRenderFns } from "./model_edit.vue?vue&type=template&id=046461ac&scoped=true"
import script from "./model_edit.vue?vue&type=script&lang=js"
export * from "./model_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046461ac",
  null
  
)

export default component.exports